<template>
  <div >
    <el-card class="box-card">
        <div class="product">
            <div class="img">
                <img :src="product.bigImg" />
            </div>
            <div class="title">{{product.name}}</div>
            <div class="price">￥{{product.price}}/{{product.unit}}</div>
        </div>
        <div style="margin-bottom:10px;">支付方式：微信</div>
        <div id="qrcode" ref="qrcode" style="text-align:center;"></div>
    </el-card>
  </div>
</template>

<script>
import img from '@/assets/banner.png'
import QRCode from 'qrcodejs2'
import {
    wxNativePay
} from '@/api/index.js'
export default {
  name: 'Home',
  data : function(){
    return {
        product : {}
    }
  },
  created() {
      this.product =  JSON.parse(window.localStorage.getItem('product')||'{}')
      wxNativePay({
          amount : this.product.price
      }).then(res=>{
          if(res.data.returnCode=='000000'){
            // this.$router.push({
            //     name : 'Success'
            // })
            let qrcode = new QRCode('qrcode',{
                width: 200, // 设置宽度，单位像素
                height: 200, // 设置高度，单位像素
                text: res.data.codeUrl // 设置二维码内容或跳转地址
            })
          }
      })
  },
  methods : {
      turn(obj){
          window.localStorage.setItem('product',JSON.stringify(obj))
          
      }
  }
}
</script>

<style>
.product{
    text-align: left;
    line-height: 1.5;
    position: relative;
}
.product .img img{
    width: 100%;
}
.product .title{
    
}
.product .price{
    color: #BD82A6;
}
.product .buy{
    position: absolute;
    right: 0;
    bottom: 0;
    color: #fff;
}
.product .buy span{
    padding: 5px 8px;
    background: #000000;
    border-radius: 2px;
    cursor: pointer;

}
#qrcode img{
    margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/Order.vue